import { SUM } from '__jsLibs/EXCEL';

const gettersRenovations = {
	RenovationsSum(state) {
		// if (
		// 	state.result['home_inspection']
		// 	&& state.result['home_inspection'] !== ''
		// 	&& state.result['repairs']
		// 	&& state.result['repairs'] !== ''
		// 	&& state.result['updates']
		// 	&& state.result['updates'] !== ''
		// ) {
		// 	return SUM([
		// 		+state.result['home_inspection'],
		// 		+state.result['repairs'],
		// 		+state.result['updates']
		// 	]);
		// }
		// return 0;
		return SUM([
			+state.result['home_inspection'],
			+state.result['repairs'],
			+state.result['updates']
		]);
	},
	TotalUpfrontInvestment(state, getters) {
		// if (getters.Downpayment && getters.ClosingCosts && getters.RenovationsSum) {
		// 	return SUM([
		// 		+getters.Downpayment,
		// 		+getters.ClosingCosts,
		// 		+getters.RenovationsSum
		// 	]);
		// }
		// return 0;
		return SUM([
			+getters.Downpayment,
			+getters.ClosingCosts,
			+getters.RenovationsSum
		]);
	}
};

export { gettersRenovations };
